import { useMemo } from 'react'
import { useReselector } from '@/utils/sharedHooks'

import { Link, Table, Text } from '@/ui'
import { getTransactionsByType } from '@/features/transactions/transactions.selectors'
import { UserViewOnlyTransactionRow } from '@/components/UserViewOnlyTransactionRow'
import { TextColors, TypographyStyles } from '@/styles'

export const ExpensesTransactionTable = () => {
  const transactions = useReselector(
    getTransactionsByType,
    'categorizedExpenses'
  )

  const transactionsToView = useMemo(
    () => transactions.slice(0, 10),
    [transactions]
  )

  return (
    <Table className="border-neutral-200 border-1 bg-neutral-0 rounded-md">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell className="w-2/12">Date</Table.HeaderCell>
          <Table.HeaderCell className="w-6/12">Description</Table.HeaderCell>
          <Table.HeaderCell className="w-2/12 text-right">
            Amount
          </Table.HeaderCell>
          <Table.HeaderCell className="w-2/12">Category</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {transactionsToView.map((transaction) => (
          <UserViewOnlyTransactionRow
            key={transaction.id}
            transaction={transaction}
          />
        ))}

        <Table.Row>
          <Table.Cell colSpan={3}>
            <Text variant={TypographyStyles.BODY_SM} color={TextColors.GREEN}>
              Viewing {transactionsToView.length} out of {transactions.length}{' '}
              transactions
            </Text>
          </Table.Cell>
          <Table.Cell className="text-right">
            <Link href="/transactions" newPage={false}>
              View All
            </Link>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  )
}
